<template>

  <div class="ibox mt-5 mx-4">
    <div class="ibox-content mx-1">

      <div class="row mt-3">

        <div class="col-md-5">
          <div class="title-1">

            <div class="icon-card mr-2">
              <component v-if="app.icon" :is="app.icon" size="3x"/>
              <XIcon v-else size="3x"/>
            </div>

            <h3 class="mr-2"><strong>{{ displayName }}</strong></h3>

<!--            <div class="app-category px-1">{{ app.category }}</div>-->

          </div>

        </div>

        <div class="col-md-7" v-if="$canNew('application', 'marketplace/view')">

          <div class="title-1 float-right">

            <button v-if="canExpressInterest" @click="expressInterest()" :disabled="toEdit" class="btn btn-outline">
              Tenho interesse
            </button>

            <strong v-else>{{ marketplaceStatusLabel }}</strong>

          </div>

        </div>
      </div>

      <div class="row mt-4">

        <div class="col-md-5">
          <div v-html="app.description"/>
        </div>

        <div class="col-md-7">

          <div class="row mb-3">
            <div class="col-md-12">

              <div class="show-image image">
                <img :src="getImage(app, currentImage)" class="img" alt="">
              </div>

            </div>
          </div>

          <div class="row">
            <div class="col-md-4" v-for="number in numbers" :key="number">
              <div class="image" :class="{'active-image': number === currentImage}">
                <img :src="getImage(app, number)" @click="changeImage(number)"
                     style="cursor: pointer" class="img" alt="?">
              </div>
            </div>
          </div>

        </div>

      </div>

    </div>

  </div>

</template>

<script>
  import { mapMutations } from 'vuex'
  import ModelMapper from '@/mixins/ModelMapper'
  import GetAccountApps from '@/mixins/GetAccountApps'
  import GetAccount from '@/mixins/GetAccount.vue'
  import { BookIcon, EditIcon, FileTextIcon, InfoIcon, MailIcon, XIcon } from 'vue-feather-icons'
  import GetPartner from '@/mixins/GetPartner'
  import { getAppDisplayName } from '@/appDisplayNames'

  const OPEN_STATUSES = [null, undefined, '', 'canceled', 'expired']

  const MARKETPLACE_STATUS_LABELS = {
    requested: 'Interesse registrado',
    trial: 'Em teste grátis',
    installed: 'Contratado'
  }

  export default {
    components: { BookIcon, EditIcon, FileTextIcon, GetAccount, InfoIcon, MailIcon, XIcon },
    computed: {
      canExpressInterest() {
        if (this.accountIsClosed)
          return false

        return OPEN_STATUSES.includes(this.accountApp.status || null)
      },
      displayName() {
        return getAppDisplayName(this.app.name, this.getPartner)
      },
      marketplaceStatusLabel() {
        return MARKETPLACE_STATUS_LABELS[this.accountApp.status] || ''
      }
    },
    created() {
      this.setNameBreadcrumb(this.displayName)
      this.accountApp = this.getAccountApps.find(accountApp => accountApp.appId === this.app.id) || {}
    },
    data() {
      return {
        accountApp: {},
        currentImage: 'First',
        name: '',
        nameModel: 'AccountApp',
        numbers: ['First', 'Second', 'Third']
      }
    },
    methods: {
      ...mapMutations(['setNameBreadcrumb']),
      changeImage(number) {
        this.currentImage = number
      },
      expressInterest() {
        this.asyncTemplateSave({ appId: this.app.id }, {
          after: async () => {
            this.$ls.remove('account_apps_cache')
            await this.loadAppsAndAccountApps()
            this.accountApp = this.getAccountApps.find(item => item.appId === this.app.id) || {}
            this.$notify.add('Interesse registrado. Nossa equipe entrará em contato em breve.')
            this.$router.push('/apps')
          }
        })
      },
      getImage(app, number) {
        return app[`file${number}Image`]  && app[`file${number}Image`].path
      },
      isContracted() {
        return !!this.activeAccountApps.some(accountApp => accountApp.appId === this.app.id)
      }
    },
    mixins: [ModelMapper, GetAccountApps, GetAccount, GetPartner],
    name: 'Form',
    props: {
      app: { required: true, type: Object },
      toEdit: { default: false, type: Boolean }
    },
    watch: {
      'app.nickname'(n, v) {
        if (n !== v)
          this.setNameBreadcrumb(this.app.nickname)
      }
    }
  }
</script>

<style scoped>

  .title-1 {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .show-image {
    /*width: 647px;*/
    height: 315px;

    background: #E1E3EB;
    border-radius: 5px;
  }

  .image .img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }

  .active-image {
    border: 1px solid #0099ff;
    border-radius: 5px;
  }

  .app-category {
    background: #F86D8F;
    border-radius: 3px;
    color: #fff;
    text-transform: uppercase;
  }

</style>
